<template>
    <v-card
        :color="color"
        class="pa-2 fill-height flex-grow-1 d-flex flex-column"
        hover
        :class="{ 'cursor-pointer': clickable }"
        @click="onClick"
    >
        <v-card-title class="justify-center text-center text-wrap">
            {{ title }}
        </v-card-title>
        <v-card-text class="text-center">
            <div class="text-h4 font-weight-bold">
                {{ displayValue }}
            </div>
            <v-card-subtitle v-if="subtitle || $slots.subtitle" class="mt-2">
                <slot name="subtitle">{{ subtitle }}</slot>
            </v-card-subtitle>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "DashboardSummaryCard",
    props: {
        title: { type: String, required: true },
        value: { type: [Number, String], default: 0 },
        subtitle: { type: String, default: "" },
        color: { type: String, default: "surface" },
        clickable: { type: Boolean, default: true },
    },
    computed: {
        displayValue() {
            return this.value;
        },
    },
    methods: {
        onClick() {
            if (this.clickable) this.$emit("click");
        },
    },
};
</script>
